import { Text } from "@itwin/itwinui-react"
import styles from "./SandboxTilesEmpty.module.css"

export const SandboxTilesEmpty = ({ message }: { message: string }) => {
  return (
    <div className={styles.container} data-test="atp-tile-empty">
      <Text isMuted>{message}</Text>
    </div>
  )
}
